import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

import { CartService } from '../../services/cart';
import { LoginService } from '../../components/Authentication/auth/login.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {
  cartCount: number = 0;
  tokenExists!: boolean;
  isClinicRoute: boolean = false;

  constructor(
    private cartService: CartService,
    private _LoginService: LoginService,
    private router: Router
  ) {}

  ngOnInit() {
    this.cartService.cartCount$.subscribe(count => {
      this.cartCount = count;
    });

    this.checkForToken();

    this.checkClinicRoute();

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkClinicRoute();
      });
  }

  checkForToken() {
    this._LoginService.token$.subscribe((token) => {
      this.tokenExists = token != null;
    });
  }

  checkClinicRoute() {
    const url = this.router.url.toLowerCase();

    this.isClinicRoute =
      url.includes('clinic') ||
      url.includes('book');
  }
}